module.exports = __webpack_public_path__ + "static/media/brand-etsy.c7769eae.png";